
import { Options, Vue } from "vue-class-component";
import Input from "@/app/ui/components/input/index.vue";
import { UserController } from "@/app/ui/controllers/UserController";
import router from "@/app/ui/router";
import debounce from "lodash/debounce";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { countries as COUNTRIES } from "@/app/infrastructures/misc/BulkData";
import { CityData } from "@/domain/entities/Location";
import isAssigned3lc from "@/app/infrastructures/misc/common-library/isAssigned3lc";
import { HubController } from "@/app/ui/controllers/HubController";
import { RequestHubList, Hub } from "@/domain/entities/Hub";
import { OptionsClass } from "@/domain/entities/MainApp";
import { FlagsUserManagement } from "@/feature-flags/flags-user-management";
import SelectPhoneCountry from "../../shipment/booking/component/select-phone-country.vue";

interface HqCountryOption {
  name: string;
  value: string;
  flag: string;
}

@Options({
  components: {
    Input,
    SelectPhoneCountry
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (this.hasChanged && !this.openSuccess) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      UserController.setOpenModalSuccess(false);
      next();
    }
  }
})
class Add extends Vue {
  isDivisionEmptyHub = true;
  goBack() {
    this.$router.back();
  }

  item = {
    status: "Active"
  };

  isDisabled = true;

  // Modal Success
  messageSuccess = "";
  get openSuccess() {
    return UserController.openModalSuccess;
  }
  onCloseSuccess() {
    router.push(`/user-management`);
  }

  // Save data
  get openSave() {
    return UserController.openModal;
  }
  onOpenSave() {
    UserController.setOpenModal(true);
  }
  onCloseSave() {
    UserController.setOpenModal(false);
  }

  _onCreate() {
    this.onCloseSave();
    UserController._onAddUser({
      username: this.username,
      email: this.email,
      phoneNumber: this.phoneNumberCode.substring(1) + this.phoneNumber,
      accountType: this.typeValue.split("_")[0],
      roleId: this.roleValue,
      referenceId: this.referenceName.value,
      assigned3Lc: this.isShowAssigned3Lc
        ? this.assignTo.map((item) => item.value).join(",")
        : "",
      hubId: Number(this.hubName.value),
      divisionId: Number(this.divisionName.value),
      shuttleId: Number(this.shuttleName.value),
      errorTitle: this.$t("userManagement.add.errorTitle"),
      hqCountry: this.isInternalAccount ? this.hqCountry?.value || "" : ""
    });
  }

  // Close when changed
  isEditTerminated = false;
  newPath = "";
  answer = false;

  get hasChanged() {
    return (
      this.username !== "" ||
      this.email !== "" ||
      this.phoneNumber !== "" ||
      this.typeName !== "" ||
      this.roleName !== "" ||
      this.referenceName !== "" ||
      this.divisionName !== "" ||
      this.hqCountry !== null
    );
  }

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  // Tipe Akun
  typeSelect = false;
  onOpenTypeSelect() {
    this.typeSelect = true;
  }
  onCloseTypeSelect() {
    this.typeSelect = false;
  }
  typeName = "";
  typeValue = "";
  onSelectType(name: string, value: string) {
    if (value === "Internal" && this.divisionName == "") {
      this.isDivisionEmptyHub = true;
    }
    this.onCloseTypeSelect();
    UserController.selectTypeActionAdd(value);
    this.isReferenceEmptyHub = false;
    this.referenceName = "";
    this.divisionName = "";
    this.typeName = name;
    this.typeValue = value;
    if (!this.isInternalAccount) this.hqCountry = null;
    if (this.isInternalAccount) this.fetchHqCountries("");
    this.assignTo = [
      { name: this.$t("userManagement.add.all") as string, value: "All" }
    ];
    this.hubName = new OptionsClass();
    this.whitelistEmail();
  }

  get roleAccount() {
    return (
      AccountController.accountData.account_type_detail.type ||
      AccountController.accountData.account_type
    );
  }
  get isClientParent() {
    return AccountController.accountData.account_type_detail.parentId === 0;
  }
  get selectLabel() {
    return this.$t(
      "userManagement.add.selectAccountType"
    ) as string
  }
  get typeData() {
    switch (this.roleAccount) {
      case "internal":
        return [
          { name: this.selectLabel, value: "" },
          { name: "Internal", value: "internal" },
          { name: "Client Parent", value: "client_parent" },
          { name: "Client Branch", value: "client_branch" },
          { name: "Vendor", value: "vendor" },
          { name: "Console", value: "console" },
          { name: "Sub-Console", value: "sub-console" },
          { name: "POS", value: "pos" },
          { name: "Customer Service", value: "customer-service" }
        ];
      case "console":
        return [
          { name: this.selectLabel, value: "" },
          { name: "Console", value: "console" }
        ];
      case "sub-console":
        return [
          { name: this.selectLabel, value: "" },
          { name: "Sub-Console", value: "sub-console" }
        ];
      case "pos":
        return [
          { name: this.selectLabel, value: "" },
          { name: "POS", value: "pos" }
        ];
      case "client":
        if (this.isClientParent) {
          return [
            { name: this.selectLabel, value: "" },
            { name: "Client Parent", value: "client_parent" },
            { name: "Client Branch", value: "client_branch" }
          ];
        }
        return [
          { name: this.selectLabel, value: "" },
          { name: "Client Branch", value: "client_branch" }
        ];
      default:
        return [{ name: this.selectLabel, value: "" }];
    }
  }

  // Role
  roleSelect = false;
  onOpenRoleSelect() {
    this.roleSelect = true;
  }
  onCloseRoleSelect() {
    this.roleSelect = false;
  }
  roleName = "";
  roleValue = 0;
  onSelectRole(name: string, value: number) {
    this.onCloseRoleSelect();
    this.roleName = name;
    this.roleValue = value;
    this.assignTo = [
      { name: this.$t("userManagement.add.all") as string, value: "All" }
    ];
  }

  get roleData() {
    const selectRoleLabel = this.$t("userManagement.add.selectRole") as string;
    return [
      { name: selectRoleLabel, value: "" },
      ...UserController.roleDataList
    ];
  }

  // Reference
  loadingReference = false;
  loadingDivision = false;
  loadingShuttle = false;
  referenceName: any = "";
  divisionName: any = "";
  shuttleName: any = "";
  referencePage = 1;
  referenceLimit = 10;
  focusListReference() {
    this.loadingReference = true;
    this.fetchListReference("");
  }
  fetchListReference = debounce(async (search: string) => {
    this.loadingReference = true;
    await UserController.getReference(search);
    this.loadingReference = false;
    // if less than 10 in referenceDataList, get the next page
    // while (this.referenceDataList.length < 10) {
    //   const oldReferenceDataLength = this.referenceDataList.length;
    //   this.referencePage++;
    //   await this.fetchListReferenceByPage(
    //     search,
    //     this.referencePage,
    //     this.referenceLimit
    //   );
    //   // if the fetch empty or doesnt provide additional data, break the loop
    //   if (this.referenceDataList.length === oldReferenceDataLength) {
    //     break;
    //   }
    // }
  }, 250);
  get referenceDataList() {
    return this.typeValue.includes("client")
      ? UserController.referenceDataList.filter((key: any) => {
          return key.isStatusClientActive;
        })
      : UserController.referenceDataList;
  }
  isReferenceEmptyHub = false;
  async onSelectReference(value: any) {
    this.isReferenceEmptyHub = false;
    if (value) {
      this.referenceName = value;
      await this.fetchListHub();
      await this.fetchListShuttle("");
      await this.$nextTick();
      this.hubName = new OptionsClass(); // reset hubName
      this.handleHubBySelectReference();
      this.shuttleName = "";
    } else {
      this.shuttleName = "";
      this.referenceName = "";
      this.hubName = new OptionsClass(); // reset hubName
    }
  }

  handleHubBySelectReference() {
    if (this.listHubDataList.length === 1) {
      this.hubName = this.listHubDataList[0];
    }

    if (!this.listHubDataList.length) {
      this.isReferenceEmptyHub = true;
    }
  }

  fetchListReferenceByPage = async (
    search: string,
    page: number,
    limit: number
  ) => {
    this.loadingReference = true;
    // await UserController.getReferenceByPage({ search, page, limit });
    this.loadingReference = false;
  };
  handleScrolledReference(search: string) {
    this.referencePage++;
    this.fetchListReferenceByPage(
      search,
      this.referencePage,
      this.referenceLimit
    );
  }
  handleBlurReference() {
    UserController.setReferenceDataList([]);
    this.referencePage = 1;
  }
  // Field Division
  focusListDivision() {
    this.loadingDivision = true;
    this.fetchListDivision("");
  }
  fetchListDivision = debounce(async (search: string) => {
    this.loadingDivision = true;
    await UserController.getDivision(search);
    this.loadingDivision = false;
  }, 250);

  get divisionDataList() {
    return UserController.divisionDataList.map((item) => ({
      name: item.divisionName,
      value: item.divisionId
    }));
  }

  onSelectDivision(value: any) {
    if (value) {
      this.divisionName = value;
      this.isDivisionEmptyHub = false;
      UserController.getRoleWithDivision({
        // eslint-disable-next-line @typescript-eslint/camelcase
        account_type: this.typeValue.split("_")[0],
        // eslint-disable-next-line @typescript-eslint/camelcase
        division_id: value.value
      });
    }
  }

  // Field Shuttle
  focusListShuttle() {
    this.loadingShuttle = true;
    this.fetchListShuttle("");
  }

  fetchListShuttle = debounce(async (search: string) => {
    this.loadingShuttle = true;

    const hubId = Number(this.hubName?.value ?? 0);
    const partnerId = Number(this.referenceName?.value ?? 0);

    await UserController.getShuttle({
      search,
      hubId,
      partnerId
    });

    this.loadingShuttle = false;
  }, 250);

  get shuttleDataList() {
    return UserController.shuttleDataList.map((item) => ({
      name: item.shuttleName,
      value: item.shuttleId
    }));
  }
  onSelectShuttle(value: any) {
    if (value) {
      this.shuttleName = value;
    }
  }

  get isConsoleAccountType() {
    return this.typeName.match(/^Console$/);
  }

  get showHubNewField() {
    return (
      this.typeName.match(/^Console$/) &&
      this.referenceName.value &&
      this.roleName
    );
  }

  get showShuttleFiled() {
    return this.referenceName.value && this.roleName;
  }

  hubPage = 1;
  hubName: OptionsClass = new OptionsClass();
  loadingHub = false;
  listHub: Hub[] = [];
  get listHubDataList() {
    return [
      ...this.listHub.map(
        (hub) =>
          new OptionsClass({
            name: hub.hubName,
            value: hub.hubId.toString()
          })
      )
    ];
  }

  async fetchListHub() {
    if (!this.typeName.match(/^Console$/)) return;
    try {
      this.hubPage = 1;
      this.loadingHub = true;
      const hubList = await HubController.getHubList(
        new RequestHubList({
          page: this.hubPage,
          partnerId: this.referenceName.value,
          city: this.referenceName.partnerCityCode,
          status: "active"
        })
      );

      this.listHub = hubList.data;
    } catch (err) {
      this.listHub = [];
    } finally {
      this.loadingHub = false;
    }
  }

  async fetchListHubInfiniteScroll() {
    this.hubPage++;
    try {
      this.loadingHub = true;
      const hubList = await HubController.getHubList(
        new RequestHubList({
          page: this.hubPage,
          partnerId: this.referenceName.value,
          city: this.referenceName.partnerCityCode,
          status: "active"
        })
      );

      this.listHub.push(...hubList.data);
    } catch (err) {
      this.listHub = [];
    } finally {
      this.loadingHub = false;
    }
  }

  async onSelectHub(value: OptionsClass) {
    if (!value) return (this.hubName = new OptionsClass());
    this.hubName = value;
    await this.fetchListShuttle("");
    this.shuttleName = "";
  }

  // validation username
  username = "";
  validUsername = true;

  validateUsername() {
    this.validUsername = /^[A-Za-z.]+$/.test(this.username);
  }

  preventNumbers(event: KeyboardEvent) {
    if (/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  get convertUsername() {
    if (this.isConsoleAccountType) {
      return `${
        this.username
      }.cons.${this.referenceName?.partnerCityCode?.toLowerCase() || ""}`;
    }

    return this.username;
  }

  // validation email
  email = "";
  validEmail = true;

  validateEmail() {
    this.validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    this.whitelistEmail();
  }

  // validate whitelist email
  isWhitelistEmail = false;

  whitelistEmail() {
    this.isWhitelistEmail = false;
    if (this.typeName.toLowerCase() === "internal") {
      const emailWhitelist = FlagsUserManagement.email_validation
        .getValue()
        .split(",");

      this.isWhitelistEmail = !emailWhitelist.some((domain) =>
        this.email?.toLowerCase().endsWith(domain)
      );
    }
  }

  // phone number
  phoneNumber = "";
  phoneNumberCode = "";

  setPhoneNumber(val: string) {
    this.phoneNumber = val;
  }

  setPhoneCodeNumber(val: string) {
    this.phoneNumberCode = val;
  }

  initPhoneCode() {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.account_type_detail?.countryCode;
    this.setPhoneCodeNumber(getPhoneDisplayCode(countryCode));
  }

  hqCountry: HqCountryOption | null = null;

  get isInternalAccount(): boolean {
    return this.typeName === "Internal";
  }

  get isLoadingHqCountry(): boolean {
    return LocationController.isLoadingCountry;
  }

  get hqCountryOptions(): HqCountryOption[] {
    const countries = LocationController.countryData.countryData.map(
      (country) => {
        return {
          name: country.name,
          value: country.code.toUpperCase(),
          flag: country.flag || ""
        };
      }
    );
    return [{ name: "All Countries", value: "ALL", flag: "" }, ...countries];
  }

  onSelectHqCountry(value: HqCountryOption | null): void {
    this.hqCountry = value;
  }

  async fetchHqCountries(search: string): Promise<void> {
    await LocationController.getCountryList({
      search,
      status: "active",
      page: 1,
      limit: 100
    });
  }

  get isFormValid() {
    const isInternal = this.typeName === "Internal";

    const divisionValue = this.divisionName?.value ?? 0;
    const isDivisionValid = !isInternal || (isInternal && divisionValue !== 0);
    const isHqCountryValid = !isInternal || !!this.hqCountry?.value;
    return [
      this.username?.trim() !== "",
      this.email?.trim() !== "",
      this.phoneNumber?.trim() !== "",
      this.validUsername,
      this.validEmail,
      this.typeValue !== "",
      this.roleValue !== 0,
      this.isValidAssignTo,
      this.isValidHub,
      !this.isWhitelistEmail,
      isDivisionValid,
      isHqCountryValid
    ].every((valid) => valid);
  }

  get isValidAssignTo() {
    return this.isShowAssigned3Lc
      ? this.assignTo.length
      : this.isValidReference;
  }
  get isValidReference() {
    if (this.typeName.match(/^Internal$|^Customer Service$/)) {
      return true;
    }
    return this.referenceName !== "";
  }

  get isValidHub() {
    if (this.isConsoleAccountType && !this.isReferenceEmptyHub)
      return !!this.hubName.value;
    return true;
  }

  get isShowAssigned3Lc() {
    return isAssigned3lc({
      accountType: this.typeName,
      roleName: this.roleName
    });
  }

  assignTo = [{ name: "Semua", value: "All" }];
  dataListCity: CityData[] = [];

  mounted() {
    if (this.assignTo.length === 1 && this.assignTo[0].value === "All") {
      this.assignTo = [
        { name: this.$t("userManagement.add.all") as string, value: "All" }
      ];
    }
    this.initPhoneCode();
  }
  // origin city
  async fetchCity(search: string) {
    const city = await LocationController.getCityList({
      search: search,
      status: "active",
      page: 1,
      limit: 20,
      newEndpoint: true
    });
    this.dataListCity = city.cityData;
  }
  filterCity = debounce((search: string) => {
    if (search.length > 2 || !search) this.fetchCity(search);
  }, 250);
  get cityExcludeOptions() {
    return this.dataListCity.map((e) => ({
      id: e.id,
      name: `${e.code}`,
      value: `${e.code}`
    }));
  }
  get cityOptions() {
    return [
      {
        name: this.$t("userManagement.add.all") as string,
        value: "All"
      },
      ...this.cityExcludeOptions
    ];
  }
  get isLoadingCity() {
    return LocationController.isLoading;
  }
  async fetchCityListInfiniteScroll(search = "") {
    const currentPage = LocationController.cityData.pagination.page + 1;
    const city = await LocationController.getCityList({
      search: search,
      status: "active",
      page: currentPage,
      limit: 20,
      newEndpoint: true
    });
    this.dataListCity.push(...city.cityData);
  }

  get showRoleWithDivision() {
    return this.isDivisionEmptyHub && this.typeName === "Internal";
  }
}
export default Add;
